import { useState, useEffect } from "react";

import io from "../lib/io";
import getAccessToken from "./getAccessToken";

const Hook = () => {
  const accessToken = getAccessToken();
  const [socket, setSocket] = useState();

  useEffect(() => {
    if (!accessToken.value) return;

    // Bug real (auditoría 2026-08-14): guardar el socket en un useRef
    // significa que conectarse NO dispara un re-render — los componentes
    // que llaman useSocket() (Agenda, Calendar, Monitor, Room, App) sólo
    // "veían" el socket ya conectado si algo AJENO los re-renderizaba
    // después; hasta entonces sus propios efectos `useEffect(() => {...},
    // [socket])` seguían viendo undefined y nunca llegaban a suscribirse.
    const instance = io(accessToken.value);
    setSocket(instance);

    return () => {
      instance.disconnect();
      setSocket(undefined);
    };
  }, [accessToken.value]);

  return socket;
};

export default Hook;
